import {gql} from "@apollo/client";

export const getOrCreateWidgetConversationMutation = gql`
    mutation GetOrCreateWidgetConversation($widgetConversationDto: WidgetConversationDto!) {
        getOrCreateWidgetConversation(widgetConversationDto: $widgetConversationDto) {
            id
        }
    }
`;
